;(function(){
	
	main();
	
	function main() {
		// document.body.addEventListener('pageshow', onPageShow);
		onPageShow();
	}
	
	/**
	 * ページ表示
	 */
	function onPageShow() {
		// スクロール
		document.querySelectorAll('.j-smooth').forEach((dom)=>{
			new SmoothScroll( dom );
		});
		// ヘッダ
		document.querySelectorAll('.j-header').forEach((dom)=>{
			new fixedHeader( dom );
		});
		// SPメニュー
		document.querySelectorAll('.j-header-spmenu').forEach((dom)=>{
			new SpMenu( dom );
		});
		// メガドロップ
		document.querySelectorAll('.j-header-parent').forEach((dom)=>{
			new Megadrop( dom );
		});
		// 検索ボタン
		document.querySelectorAll('.j-header-searchbtn').forEach((dom)=>{
			new SearchBtn( dom );
		});
		// 固定index
		document.querySelectorAll('.j-fixed-index').forEach((dom)=>{
			new FixedIndex( dom );
		});
		// 商品詳細のし選択
		document.querySelectorAll('.j-form-noshi').forEach((dom)=>{
			new FormNoshi( dom );
		});
		// 商品詳細スライダー
		document.querySelectorAll('.j-subimage-slide').forEach((dom)=>{
			new SubImageSlider( dom );
		});
		// 商品詳細タブ
		document.querySelectorAll('.j-product-tab').forEach((dom)=>{
			new ProductTab( dom );
		});
		// ピックアップスライダー
		document.querySelectorAll('.j-pickup-slide').forEach((dom)=>{
			new PickupSlider( dom );
		});
        setTimeout(()=>{
          document.querySelectorAll('.j-pickup-slide').forEach((dom)=>{
            if ( ! dom.classList.contains('pickup-slide-initialized') ) {
              new PickupSlider( dom );
            }
          });
        }, 3000);
		
		// 取り扱い商品種目
		document.querySelectorAll('.j-lineup-slider').forEach(function(dom){
			new LineupSlider( dom );
		});
		document.querySelectorAll('.j-lineup-accordion').forEach(function(dom){
			new LineupAccordion( dom );
		});
		
		// サービス
		document.querySelectorAll('.j-service-slider').forEach(function(dom){
			new ServiceSlider( dom );
		});
		
		// エフェクト
		new InviewElements();
		
		// モーダル
		if ( document.querySelector('.j-image-modal') ) {
			new ImageModal();
		}

        // yotpo商品レビュータイトル調整
        if ( document.querySelectorAll('.yotpo-widget-instance') ) {
          new YotpoAddFunction();
        }

        // SPメニュー：商品メニューの子階層展開
        let $btnChild = document.querySelectorAll( '.toggleChildOpen' );
        $btnChild.forEach((btn)=>{
            btn.addEventListener('click', (evt)=>{
                let result = evt.target.classList.contains( 'is-open' );
                let target = evt.target.nextElementSibling;
                if ( result ) {
                    // close
                    gsap.to(target, { height: 0, duration: 0.5 });
                    evt.target.classList.remove( 'is-open' );
                } else {
                    // open
                    gsap.to(target, { height: 'auto', duration: 0.5 });
                    evt.target.classList.add( 'is-open' );

                    // 既にopenしている子階層を閉じる
                    $btnChild.forEach((btn)=>{
                        //console.log(btn.dataset.index, evt.target.dataset.index );
                        if ( btn.dataset.index != evt.target.dataset.index && btn.classList.contains('is-open') ) {
                            const event = new Event('click');
                            btn.dispatchEvent(event);
                        }
                    });
                }
            });
        });
	}
	
	/**
	 * スムーススクロール
	 */
	function SmoothScroll( dom ) {
		let $link = dom;
		let $header = document.querySelector('.j-header');
		
		_init();
		
		function _init() {
			$link.addEventListener('click', _onClickLink);
		}
		
		function _onClickLink(evt) {
			evt.preventDefault();
			
			let href = $link.getAttribute('href');
			let $target = document.querySelector( href );
			let rect = $target.getBoundingClientRect();
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			let offsetTop = rect.top + scrollTop;
			let headerHeight = $header.offsetHeight + $header.offsetTop;
			
			console.log( $target, rect, scrollTop, offsetTop );
			
			window.scrollTo( 0, offsetTop - headerHeight );
		}
	}
	
	/**
	 * ヘッダ
	 */
	function fixedHeader( dom ) {
		let CHECK_BUFF = 10; // px
		let $header = dom;
		let $homeFeature = document.querySelector('.p-home-feature');
        let $announce = document.querySelector('#shopify-section-announcement-bar');
        let $main = document.querySelector('#MainContent');
		let scroll = 0;
		
		_init();
		
		function _init() {
			// requestAnimationFrame(_checkHidden);
			if ( $homeFeature ) {
				requestAnimationFrame(_checkBg);
			}
			else {
				$header.classList.add('is-bg-enabled');
			}
            _checkHeaderPosition();
		}

        function _checkHeaderPosition() {
          let top = 0;
          let paddingTop = $header.offsetHeight;
          let filterTop = 0;
          let $filter = document.querySelector('.boost-sd__filter-tree-vertical-sticky-overlay');
          
          if ( $announce ) {
            top += $announce.offsetHeight;
            paddingTop += $announce.offsetHeight;
            filterTop += $announce.offsetHeight;
          }
          $header.style.top = top + 'px';

          if ( ! document.body.classList.contains('tpl-index') ) {
            $main.style.paddingTop = paddingTop + 'px';
          }
          if ( $filter ) {
            $filter.style.top = filterTop + 'px';
          }
    	  requestAnimationFrame(_checkHeaderPosition);
        }
		
		function _checkHidden() {
			let temp_scroll = window.scrollY;
			
			if ( temp_scroll > scroll + CHECK_BUFF ) {
				$header.classList.add('is-hidden');
			}
			if ( temp_scroll < scroll - CHECK_BUFF ) {
				$header.classList.remove('is-hidden');
			}
			scroll = temp_scroll;
			
			requestAnimationFrame(_checkHidden);
		}
		
		function _checkBg() {
			let top = $homeFeature.offsetTop + $homeFeature.offsetHeight - $header.offsetHeight - $header.offsetTop;
			let scroll = window.scrollY;
			
			if ( scroll > top ) {
				$header.classList.add('is-bg-enabled');
			}
			else {
				$header.classList.remove('is-bg-enabled');
			}
			
			requestAnimationFrame(_checkBg);
		}
	}
	
	// SPメニュー
	function SpMenu( dom ) {
		let $btn = dom;
		
		_init();
		
		function _init() {
			$btn.addEventListener('click', _onClickBtn);
		}
		
		function _onClickBtn( evt ) {
			$btn.classList.toggle('is-active');
			document.querySelector('.j-header-nav').classList.toggle('is-visible');
		}
	}
	
	// メガドロップ
	function Megadrop( dom ) {
		let $parent = dom;
		let $child = $parent.nextElementSibling;
		let $all = document.querySelectorAll('.l-header__gnav__child');
        let $spmenu = document.querySelector('.j-header-spmenu');
		
		_init();
		
		function _init() {
			$parent.addEventListener('click', _onClickParent);
		}
		
		function _onClickParent( evt ) {
            if ( ! _isSp() ) {
              return true;
            }
			evt.preventDefault();
			
			if ( $child.classList.contains('is-visible') ) {
				$child.classList.remove('is-visible');
			}
			else {
				$all.forEach(( $childItem )=>{
					$childItem.classList.remove('is-visible');
				});
				$child.classList.add('is-visible');
			}
		}

        function _isSp() {
          let styles = window.getComputedStyle( $spmenu );

          return ( styles['display'] == 'block' );
        }
	}
	
	// 検索ボタン
	function SearchBtn( dom ) {
		let $btn = dom;
		
		_init();
		
		function _init() {
			$btn.addEventListener('click', _onClickBtn);
		}
		
		function _onClickBtn( evt ) {
			document.querySelector('.j-header-search').classList.toggle('is-visible');
		}
	}
	
	// 固定index
	function FixedIndex( dom ) {
		let $base = dom;
		let $switch = $base.querySelector('.j-fixed-index__switch');
		let $sparea = $base.querySelector('.j-fixed-index__sp');
		let $header = document.querySelector('.j-header');
		let $mv = document.querySelector('.j-fixed-index__mv');
		let $bar = document.getElementById('shopify-section-announcement-bar');
		let $links = $sparea.querySelectorAll('a');
        let isPc = window.matchMedia('(min-width: 990px)');
		
		_init();
		
		function _init() {
			$switch.addEventListener('click', _onClickSwitch);
			$links.forEach(( $link )=>{
				$link.addEventListener('click', _onClickLink);
			});
			_checkFixed();
		}
		
		function _onClickSwitch() {
			if ( $sparea.classList.contains('is-visible') ) {
				$switch.classList.remove('is-active');
				$sparea.classList.remove('is-visible');
			}
			else {
				$switch.classList.add('is-active');
				$sparea.classList.add('is-visible');
			}
		}
		
		function _onClickLink() {
			$switch.classList.remove('is-active');
			$sparea.classList.remove('is-visible');
		}
		
		function _checkFixed() {
			let scroll = ( document.body.scrollTop ) ? document.body.scrollTop : window.scrollY;
			let start = $mv.offsetHeight;
            let top = $header.offsetHeight;
			
			if ( $bar ) {
				document.body.classList.add('is-with-announce-bar');
				// start += $bar.offsetHeight;
				top += $bar.offsetHeight;
			}
			else {
				document.body.classList.remove('is-with-announce-bar');
			}
			
			if ( isPc.matches && scroll <= start ) {
				document.body.classList.remove('is-index-fixed');
				$base.style.top = '';
			}
			else {
				document.body.classList.add('is-index-fixed');
				$base.style.top = top + 'px';
			}
			requestAnimationFrame( _checkFixed );
		}
	}
	
	// 商品詳細のし選択
	function FormNoshi( dom ) {
		let $base = dom;
		let $checks = document.querySelectorAll('input[name="properties[熨斗]"]');
		let $check_noshigami = document.querySelectorAll('input[name="properties[熨斗紙]"]');
		let $check_kakekata = document.querySelectorAll('input[name="properties[かけ方]"]');
		let $input_omotegaki = document.querySelector('input[name="properties[表書き]"]');
		let $input_okurinushi = document.querySelector('input[name="properties[贈り主名]"]');
		
		_init();
		
		function _init() {
			if ( $checks ) {
				$checks.forEach(( $check )=>{
					$check.addEventListener('click', _onClickRadio);
				});
			}
			_check();
		}
		
		function _onClickRadio(e) {
			_check();
		}
		
		function _check() {
			let $checked = document.querySelector('input[name="properties[熨斗]"]:checked');
			if ( ! $checked ) {
				return;
			}
			let val = $checked.getAttribute('value');
			if ( val == '希望する' ) {
				_show();
			}
			else {
				_hide();
			}
		}
		
		function _show() {
			$base.classList.add('is-visible');
		}
		
		function _hide() {
			$base.classList.remove('is-visible');
			
			if ( $check_noshigami ) {
				$check_noshigami.forEach(($input)=>{
					$input.checked = false;
				});
			}
			if ( $check_kakekata ) {
				$check_kakekata.forEach(($input)=>{
					$input.checked = false;
				});
			}
			if ( $input_omotegaki ) {
				$input_omotegaki.value = '';
			}
			if ( $input_okurinushi ) {
				$input_okurinushi.value = '';
			}
		}
	}
	
	// 商品詳細スライダー
	function SubImageSlider( dom ) {
		let TOUCH_BUFF = 10; // px
		let $base = dom;
		let $scroll = $base.querySelector('.j-subimage-slide__scroll');
		let $prev = $base.querySelector('.j-subimage-slide__prev');
		let $next = $base.querySelector('.j-subimage-slide__next');
		let $isSp = $base.querySelector('.j-subimage-slide__issp');
		let stock = [];
		let current = 0;
		let pagePer;
		let max;
		let lock = false;
		let touching = false;
		let dragging = false;
		let scrolling = false;
		let touchStart = { x: 0, y: 0 };
		let touchMove = { x: 0, y: 0 };
		
		_init();
		
		function _init() {
			$base.classList.add('subimage-slide-initialized');
			
			let $items = $scroll.querySelectorAll('.j-subimage-slide__item');
			$items.forEach(($item)=>{
				stock.push( $item.cloneNode( true ) );
			});
			
			_resize();
			_reset();
			
			window.addEventListener('resize', _onResize);
			$prev.addEventListener('click', _onClickPrev);
			$next.addEventListener('click', _onClickNext);
		}
	
		function _isSp() {
			console.log( $isSp, document.defaultView.getComputedStyle );
			let style = document.defaultView.getComputedStyle($isSp, '');
			return ( style.getPropertyValue('display') == 'block' );
		}
		
		function _resize() {
			let $item = $scroll.querySelector('.j-subimage-slide__item');
			// let itemWidth = $item.offsetWidth;
			pagePer = _isSp() ? 2 : 3;
			max = Math.ceil( stock.length / pagePer ) - 1;
			
			$base.removeEventListener('touchstart', _onTouchStart);
			// $base.removeEventListener('mousedown', _onTouchStart);
			
			if ( max < 1 ) {
				$prev.disabled = true;
				$next.disabled = true;
			}
			else {
				$prev.disabled = false;
				$next.disabled = false;
				$base.addEventListener('touchstart', _onTouchStart);
				// $base.addEventListener('mousedown', _onTouchStart);
			}
		}
		
		function _reset() {
			current = 0;
			$scroll.innerHTML = '';
			$scroll.style.left = '0%';
			
			_makeColumn( 1 );
			
			document.dispatchEvent( new Event('update') );
		}
	
		function _makeColumn( direction ) {
			let $column = document.createElement('div');
			$column.classList.add('product__sub-image__column');
			$column.classList.add('j-subimage-slide__column');
			let start = pagePer * current;
			let end = start + pagePer;
			
			for ( let i = start; i < end; i ++ ) {
				if ( typeof stock[i] !== 'undefined') {
					let $item = stock[i].cloneNode(true);
					$column.append( $item );
				}
			}
			if ( direction > 0 ) {
				$scroll.append( $column );
			}
			else {
				$scroll.prepend( $column );
			}
		}
		
		function _movePrev() {
			current = ( current > 0 ) ? current - 1 : max;
			_slide(-1);
		}
		
		function _moveNext() {
			current = ( current < max ) ? current + 1 : 0;
			_slide(1);
		}
		
		function _onResize() {
			let prevPagePer = pagePer;
			
			_resize();
	
			if ( prevPagePer != pagePer ) {
				_reset();
			}
		}
		
		function _onTouchStart( evt ) {
			if ( touching || lock ) {
				return;
			}
			touching = true;
			dragging = false;
			scrolling = false;
		
			touchStart = {
				x: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientX : evt.clientX,
				y: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientY : evt.clientY
			};
			touchMove = { x: 0, y: 0 };
		
			document.addEventListener('touchmove', _onTouchMove, { passive: false });
			document.addEventListener('touchend', _onTouchEnd);
			// document.addEventListener('mousemove', _onTouchMove, { passive: false });
			// document.addEventListener('mouseup', _onTouchEnd);
		}
		
		function _onTouchMove( evt ) {
			let touchTemp = {
				x: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientX : evt.clientX,
				y: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientY : evt.clientY
			};
			touchMove = {
				x: touchTemp.x - touchStart.x,
				y: touchTemp.y - touchTemp.y
			};
		
			if ( ! dragging && ! scrolling ) {
				if ( Math.abs( touchMove.x ) > Math.abs( touchMove.y ) && Math.abs( touchMove.x ) > TOUCH_BUFF ) {
					dragging = true;
				}
				else if ( Math.abs( touchMove.x ) < Math.abs( touchMove.y ) && Math.abs( touchMove.y ) > TOUCH_BUFF ) {
					scrolling = true;
				}
			}
			if ( dragging && evt.cancelable ) {
				evt.preventDefault();
				evt.stopPropagation();
			}
		}
		
		function _onTouchEnd() {
			document.removeEventListener('touchmove', _onTouchMove, { passive: false });
			document.removeEventListener('touchend', _onTouchEnd);
			// document.removeEventListener('mousemove', _onTouchMove, { passive: false });
			// document.removeEventListener('mouseup', _onTouchEnd);
		
			if ( lock ) {
				return;
			}
			if ( dragging ) {
				if ( touchMove.x > 0 ) {
					_movePrev();
				}
				else {
					_moveNext();
				}
			}
			touching = false;
			dragging = false;
			scrolling = false;
		}
		
		function _onClickPrev() {
			if ( lock ) {
				return;
			}
			_movePrev();
		}
		
		function _onClickNext() {
			if ( lock ) {
				return;
			}
			_moveNext();
		}
		
		function _slide( direction ) {
			lock = true;
	
			let leftStart = ( direction > 0 ) ? 0 : -100;
			let leftEnd = ( direction > 0 ) ? -100 : 0;
			let duration = 500; // msec
			let startTime = null;
	
			if ( direction > 0	) {
			_makeColumn( 1 );
			}
			else {
			_makeColumn( -1 );
			}
			$scroll.style.left = leftStart + '%';
			
			requestAnimationFrame(__anim);
	
			function __anim( currentTime ) {
				if ( startTime === null ) {
					startTime = currentTime;
				}
				let timeElapsed = currentTime - startTime;
				let run = __ease( timeElapsed, leftStart, leftEnd - leftStart, duration );
				$scroll.style.left = run + '%';
	
				if ( timeElapsed < duration ) {
					requestAnimationFrame( __anim );
				}
				else {
					_animEnd();
				}
			}
	
			function _animEnd() {
			if ( direction > 0 ) {
				$scroll.childNodes[0].remove();
			}
			else {
				$scroll.childNodes[ $scroll.childNodes.length - 1 ].remove();
			}
			$scroll.style.left = '0%';
			
			document.dispatchEvent( new Event('update') );
			lock = false;
			}
	
			function __ease( t, b, c, d ) {
				t /= d / 2;
				if (t < 1) return c / 2 * t * t + b;
				t--;
				return -c / 2 * (t * (t - 2) - 1) + b;
			}
		}
	}
	
	// 商品詳細タブ
	function ProductTab( dom ) {
		let $base = dom;
		let $tabs = $base.querySelectorAll('a');
		let $contents = document.querySelectorAll('.j-product-tab__contents');
		
		_init();

		function _init() {
			$tabs.forEach(( $tab )=>{
				$tab.addEventListener('click', _onClickTab );
			});
			$contents.forEach(( $content )=>{
				$content.style.display = 'none';
			});
          
            $tabs[0].classList.add('is-active');
            $contents[0].style.display = 'block';
            $contents[0].classList.add('is-visible');
            /*
            $contents[0].querySelectorAll('is-inview').forEach(( $inview )=>{
                $inview.classList.remove('is-inview');
            });
            */
		}
		
		function _onClickTab( evt ) {
			evt.preventDefault();
			let $current = evt.currentTarget;
			
			$tabs.forEach(( $tab )=>{
				if ( $current.getAttribute('href') == $tab.getAttribute('href') ) {
					$tab.classList.add('is-active');
				}
				else {
					$tab.classList.remove('is-active')
				}
			});
			$contents.forEach(( $content )=>{
				if ( $current.getAttribute('href') === '#' + $content.getAttribute('id') ) {
					$content.querySelectorAll('is-inview').forEach(( $inview )=>{
						$inview.classList.remove('is-inview');
					});
					$content.style.display = 'block';
					requestAnimationFrame(()=>{
						$content.classList.add('is-visible');
					});
				}
				else {
					$content.style.display = 'none';
					$content.classList.remove('is-visible');
				}
			});
		}
	}
	
	// ピックアップスライダー
	function PickupSlider( dom ) {
		let TOUCH_BUFF = 10; // px
		let $base = dom;
		let $scroll = $base.querySelector('.j-pickup-slide__scroll');
		let $prev = $base.querySelector('.j-pickup-slide__prev');
		let $next = $base.querySelector('.j-pickup-slide__next');
		let $isSp = $base.querySelector('.j-pickup-slide__issp');
		let baseWidth = $base.offsetWidth;
		let stock = [];
		let current = 0;
		let pagePer;
		let max;
		let lock = false;
		let touching = false;
		let dragging = false;
		let scrolling = false;
		let touchStart = { x: 0, y: 0 };
		let touchMove = { x: 0, y: 0 };
		
		_init();
		
		function _init() {
			$base.classList.add('pickup-slide-initialized');
			
			let $items = $scroll.querySelectorAll('.j-pickup-slide__item');
			$items.forEach(($item)=>{
				stock.push( $item.cloneNode( true ) );
			});
			
			_resize();
			_reset();
			
			window.addEventListener('resize', _onResize);
			$prev.addEventListener('click', _onClickPrev);
			$next.addEventListener('click', _onClickNext);
		}
	
		function _isSp() {
			let style = document.defaultView.getComputedStyle($isSp, '');
			return ( style.getPropertyValue('display') == 'block' );
		}
	
		function _resize() {
			let $item = $scroll.querySelector('.j-pickup-slide__item');
			// let itemWidth = $item.offsetWidth;
			pagePer = _isSp() ? 2 : 4;
			max = Math.ceil( stock.length / pagePer ) - 1;
			
			$base.removeEventListener('touchstart', _onTouchStart);
			$base.removeEventListener('mousedown', _onTouchStart);
			
			if ( max < 1 ) {
				$prev.disabled = true;
				$next.disabled = true;
			}
			else {
				$prev.disabled = false;
				$next.disabled = false;
				$base.addEventListener('touchstart', _onTouchStart);
				$base.addEventListener('mousedown', _onTouchStart);
			}
		}
		
		function _reset() {
			current = 0;
			$scroll.innerHTML = '';
			$scroll.style.left = '0%';
			
			_makeColumn( 1 );
		
			document.dispatchEvent( new Event('update') );
		}
	
		function _makeColumn( direction ) {
			let $column = document.createElement('div');
			$column.classList.add('m-pickup-column');
			$column.classList.add('j-pickup-slide__column');
			let start = pagePer * current;
			let end = start + pagePer;
		
			for ( let i = start; i < end; i ++ ) {
				if ( typeof stock[i]	!== 'undefined') {
				let $item = stock[i].cloneNode(true);
				$item.classList.remove('is-inview');
				$column.append( $item );
				}
			}
			if ( direction > 0 ) {
				$scroll.append( $column );
			}
			else {
				$scroll.prepend( $column );
			}
		}
		
		function _movePrev() {
			current = ( current > 0 ) ? current - 1 : max;
			_slide(-1);
		}
		
		function _moveNext() {
			current = ( current < max ) ? current + 1 : 0;
			_slide(1);
		}
		
		function _onResize() {
			let prevPagePer = pagePer;
			
			_resize();
		
			if ( prevPagePer != pagePer ) {
				_reset();
			}
		}
		
		function _onTouchStart( evt ) {
			if ( touching || lock ) {
				return;
			}
			touching = true;
			dragging = false;
			scrolling = false;
			
			touchStart = {
				x: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientX : evt.clientX,
				y: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientY : evt.clientY
			};
			touchMove = { x: 0, y: 0 };
			
			document.addEventListener('touchmove', _onTouchMove, { passive: false });
			document.addEventListener('touchend', _onTouchEnd);
			document.addEventListener('mousemove', _onTouchMove, { passive: false });
			document.addEventListener('mouseup', _onTouchEnd);
		}
		
		function _onTouchMove( evt ) {
			let touchTemp = {
				x: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientX : evt.clientX,
				y: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientY : evt.clientY
			};
			touchMove = {
				x: touchTemp.x - touchStart.x,
				y: touchTemp.y - touchTemp.y
			};
			
			if ( ! dragging && ! scrolling ) {
				if ( Math.abs( touchMove.x ) > Math.abs( touchMove.y ) && Math.abs( touchMove.x ) > TOUCH_BUFF ) {
					dragging = true;
				}
				else if ( Math.abs( touchMove.x ) < Math.abs( touchMove.y ) && Math.abs( touchMove.y ) > TOUCH_BUFF ) {
					scrolling = true;
				}
			}
			if ( dragging && evt.cancelable ) {
				evt.preventDefault();
				evt.stopPropagation();
			}
		}
		
		function _onTouchEnd() {
			document.removeEventListener('touchmove', _onTouchMove, { passive: false });
			document.removeEventListener('touchend', _onTouchEnd);
			document.removeEventListener('mousemove', _onTouchMove, { passive: false });
			document.removeEventListener('mouseup', _onTouchEnd);
			
			if ( lock ) {
				return;
			}
			if ( dragging ) {
				if ( touchMove.x > 0 ) {
					_movePrev();
				}
				else {
					_moveNext();
				}
			}
			touching = false;
			dragging = false;
			scrolling = false;
		}
		
		function _onClickPrev() {
			if ( lock ) {
				return;
			}
			_movePrev();
		}
		
		function _onClickNext() {
			if ( lock ) {
				return;
			}
			_moveNext();
		}
		
		function _slide( direction ) {
			lock = true;
		
			let leftStart = ( direction > 0 ) ? 0 : -100;
			let leftEnd = ( direction > 0 ) ? -100 : 0;
			let duration = 500; // msec
			let startTime = null;
		
			if ( direction > 0	) {
				_makeColumn( 1 );
			}
			else {
				_makeColumn( -1 );
			}
			$scroll.style.left = leftStart + '%';
			
			requestAnimationFrame(__anim);
			
			function __anim( currentTime ) {
				if ( startTime === null ) {
					startTime = currentTime;
				}
				let timeElapsed = currentTime - startTime;
				let run = __ease( timeElapsed, leftStart, leftEnd - leftStart, duration );
				$scroll.style.left = run + '%';
		
				if ( timeElapsed < duration ) {
					requestAnimationFrame( __anim );
				}
				else {
					_animEnd();
				}
			}
		
			function _animEnd() {
				if ( direction > 0 ) {
					$scroll.childNodes[0].remove();
				}
				else {
					$scroll.childNodes[ $scroll.childNodes.length - 1 ].remove();
				}
				$scroll.style.left = '0%';
				
				document.dispatchEvent( new Event('update') );
				lock = false;
			}
		
			function __ease( t, b, c, d ) {
				t /= d / 2;
				if (t < 1) return c / 2 * t * t + b;
				t--;
				return -c / 2 * (t * (t - 2) - 1) + b;
			}
		}
	}
	
	// 取り扱い商品種目
	function LineupAccordion( dom ) {
		let $switch = dom;
		
		_init();
		
		function _init() {
			$switch.addEventListener('click', _onClickSwitch);
		}
		
		function _onClickSwitch( evt ) {
			if ( $switch.classList.contains('is-active') ) {
				$switch.classList.remove('is-active');
			}
			else {
				document.querySelectorAll('.j-lineup-accordion').forEach(function($item){
					$item.classList.remove('is-active');
				});
				$switch.classList.add('is-active');
			}
		}
	}
	
	// サービス
	function ServiceSlider( dom ) {
		let TOUCH_BUFF = 10; // px
		let $base = dom;
		let $scroll = $base.querySelector('.j-service-slider__scroll');
		let $items = $base.querySelectorAll('.j-service-slider__item');
		let $prev = $base.querySelector('.j-service-slider__prev');
		let $next = $base.querySelector('.j-service-slider__next');
		let $isSp = $base.querySelector('.j-service-slider__isSp');
		let current = 0;
		let max = $items.length - 1;
		let lock = false;
		let touching = false;
		let dragging = false;
		let scrolling = false;
		let touchStart = { x: 0, y: 0 };
		let touchMove = { x: 0, y: 0 };
		
		_init();
		
		function _init() {
			window.addEventListener('resize', _resize);
			
			$scroll.style.left = '0px';
			$base.addEventListener('touchstart', _onTouchStart);
			$prev.addEventListener('click', _onClickPrev);
			$next.addEventListener('click', _onClickNext);
			_updateNav();
		}
		
		function _movePrev() {
			current = current - 1;
			_fixPos();
			_updateNav();
		}
		
		function _moveNext() {
			current = current + 1;
			_fixPos();
			_updateNav();
		}
		
		function _onTouchStart( evt ) {
			if ( touching || lock ) {
				return;
			}
			if ( ! _isSp() ) {
				return;
			}
			touching = true;
			dragging = false;
			scrolling = false;
			
			touchStart = {
				x: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientX : evt.clientX,
				y: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientY : evt.clientY
			};
			touchMove = { x: 0, y: 0 };
			
			document.addEventListener('touchmove', _onTouchMove, { passive: false });
			document.addEventListener('touchend', _onTouchEnd);
		}
		
		function _onTouchMove( evt ) {
			let touchTemp = {
				x: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientX : evt.clientX,
				y: ( typeof evt['touches'] != 'undefined' ) ? evt['touches'][0].clientY : evt.clientY
			};
			touchMove = {
				x: touchTemp.x - touchStart.x,
				y: touchTemp.y - touchTemp.y
			};
			
			if ( ! dragging && ! scrolling ) {
				if ( Math.abs( touchMove.x ) > Math.abs( touchMove.y ) && Math.abs( touchMove.x ) > TOUCH_BUFF ) {
					dragging = true;
				}
				else if ( Math.abs( touchMove.x ) < Math.abs( touchMove.y ) && Math.abs( touchMove.y ) > TOUCH_BUFF ) {
					scrolling = true;
				}
			}
			if ( dragging && evt.cancelable ) {
				evt.preventDefault();
				evt.stopPropagation();
			}
		}
		
		function _onTouchEnd() {
			document.removeEventListener('touchmove', _onTouchMove, { passive: false });
			document.removeEventListener('touchend', _onTouchEnd);
			
			if ( lock ) {
				return;
			}
			if ( dragging ) {
				if ( touchMove.x > 0 ) {
					if ( current > 0 ) {
						_movePrev();
					}
				}
				else {
					if ( current < max ) {
						_moveNext();
					}
				}
			}
			touching = false;
			dragging = false;
			scrolling = false;
		}
		
		function _onClickPrev() {
			if ( lock ) {
				return;
			}
			_movePrev();
		}
		
		function _onClickNext() {
			if ( lock ) {
				return;
			}
			_moveNext();
		}
		
		function _resize() {
			let left = $base.offsetWidth * current * -1;
			$scroll.style.left = left + 'px';
		}
		
		function _fixPos() {
			lock = true;
			
			let leftStart = parseFloat( $scroll.style.left );
			let leftEnd = $base.offsetWidth * current * -1;
			let duration = 500; // msec
			let startTime = null;
			
			requestAnimationFrame(__anim);
			
			function __anim( currentTime ) {
				if ( startTime === null ) {
					startTime = currentTime;
				}
				let timeElapsed = currentTime - startTime;
				let run = __ease( timeElapsed, leftStart, leftEnd - leftStart, duration );
				$scroll.style.left = run + 'px';
				
				if ( timeElapsed < duration ) {
					requestAnimationFrame( __anim );
				}
				else {
					_animEnd();
				}
			}
			
			function _animEnd() {
				$scroll.style.left = leftEnd + 'px';
				lock = false;
			}
			
			function __ease( t, b, c, d ) {
				t /= d / 2;
				if (t < 1) return c / 2 * t * t + b;
				t--;
				return -c / 2 * (t * (t - 2) - 1) + b;
			}
			
		}
		
		function _updateNav() {
			if ( current > 0 ) {
				$prev.removeAttribute('disabled');
			}
			else {
				$prev.setAttribute('disabled', true);
			}
			
			if ( current < max ) {
				$next.removeAttribute('disabled');
			}
			else {
				$next.setAttribute('disabled', true);
			}
		}
		
		function _isSp() {
			let style = window.getComputedStyle( $isSp );
			return ( style.getPropertyValue('display') == 'block' );
		}
	}
	
	function LineupSlider( dom ) {
		let $base = dom;
		let $nav = $base.querySelector('.j-lineup-slider__nav');
		let $navLinks = $nav.querySelectorAll('a');
		let $scroll = $base.querySelector('.j-lineup-slider__scroll');
		let $items = $base.querySelectorAll('.j-lineup-slider__item');
		let $prev = $base.querySelector('.j-lineup-slider__prev');
		let $next = $base.querySelector('.j-lineup-slider__next');
		let current = 0;
		let max = $items.length - 1;
		let lock = false;
		
		_init();
		
		function _init() {
			window.addEventListener('resize', _resize);
			
			$scroll.style.left = '0px';
			$navLinks.forEach(( $navLink, i )=>{
				$navLink.addEventListener('click', (evt) =>{
					evt.preventDefault();
					_onClickNav( i );
				});
			});
			$prev.addEventListener('click', _onClickPrev);
			$next.addEventListener('click', _onClickNext);
			_updateNav();
		}
		
		function _onClickNav( idx ) {
			if ( lock ) {
				return;
			}
			if ( current == idx ) {
				return;
			}
			current = idx;
			_fixPos();
			_updateNav();
		}
		
		function _onClickPrev() {
			if ( lock ) {
				return;
			}
			current = current - 1;
			_fixPos();
			_updateNav();
		}
		
		function _onClickNext() {
			if ( lock ) {
				return;
			}
			current = current + 1;
			_fixPos();
			_updateNav();
		}
		
		function _resize() {
			let baseWidth = $scroll.offsetWidth;
			let left = baseWidth * current * -1;
			
			$scroll.style.left = left + 'px';
		}
		
		function _fixPos() {
			lock = true;
			
			let leftStart = parseFloat( $scroll.style.left );
			let leftEnd = $scroll.offsetWidth * current * -1;
			let duration = 500; // msec
			let startTime = null;
			
			requestAnimationFrame(__anim);
			
			function __anim( currentTime ) {
				if ( startTime === null ) {
					startTime = currentTime;
				}
				let timeElapsed = currentTime - startTime;
				let run = __ease( timeElapsed, leftStart, leftEnd - leftStart, duration );
				$scroll.style.left = run + 'px';
				
				if ( timeElapsed < duration ) {
					requestAnimationFrame( __anim );
				}
				else {
					_animEnd();
				}
			}
			
			function _animEnd() {
				$scroll.style.left = leftEnd + 'px';
				lock = false;
			}
			
			function __ease( t, b, c, d ) {
				t /= d / 2;
				if (t < 1) return c / 2 * t * t + b;
				t--;
				return -c / 2 * (t * (t - 2) - 1) + b;
			}
			
		}
		
		function _updateNav() {
			$navLinks.forEach(( $navLink, idx )=>{
				if ( idx == current ) {
					$navLink.classList.add('is-active');
				}
				else {
					$navLink.classList.remove('is-active');
				}
			});
			
			if ( current > 0 ) {
				$prev.removeAttribute('disabled');
			}
			else {
				$prev.setAttribute('disabled', true);
			}
			
			if ( current < max ) {
				$next.removeAttribute('disabled');
			}
			else {
				$next.setAttribute('disabled', true);
			}
		}
	}
	
	// エフェクト
	function InviewElements() {
		let SCROLL_BUFF = 0.7;
		let SIDE_BUFF = 30; // px
		
		_init();
		
		function _init() {
			setTimeout( _check, 500 );
		}
		
		function _check() {
			let $elements = document.querySelectorAll('.j-inview');
            let scroll = window.scrollY;
			let wh = window.innerHeight;
			let ww = document.body.clientWidth;
			let center_left = SIDE_BUFF;
			let center_right = ww - SIDE_BUFF;
			
			if ( ww > 1280 ) {
				center_left = ( ww - 1280 ) / 2;
				center_right = ( ww - 1280 ) / 2 + 1280;
			}
			
			$elements.forEach(( $element )=>{
				let rect = $element.getBoundingClientRect();
				
				if ( rect.top < wh * SCROLL_BUFF && center_left < Math.floor( rect.left ) + Math.floor( rect.width ) && Math.ceil( rect.left ) < center_right ) {
					$element.classList.add('is-inview');
				}
				else if ( rect.top > wh || center_left >= Math.ceil( rect.left ) + Math.ceil( rect.width ) || Math.floor( rect.left ) >= center_right ) {
					$element.classList.remove('is-inview');
				}
			});
			
			requestAnimationFrame( _check );
		}
	}
	
	// 画像モーダル
	function ImageModal() {
		let $modal = document.createElement('div');
		$modal.classList.add('m-image-modal');
		$modal.innerHTML =
			'<div class="m-image-modal__bg"></div>' +
			'<div class="m-image-modal__in">' +
				'<div class="m-image-modal__center">' +
					'<div class="m-image-modal__container"></div>' +
					'<button class="m-image-modal__close"></button>' +
				'</div>' +
			'</div>';
		document.body.appendChild( $modal );
		
		let $bg = $modal.querySelector('.m-image-modal__bg');
		let $in = $modal.querySelector('.m-image-modal__in');
		let $center = $modal.querySelector('.m-image-modal__center');
		let $container = $modal.querySelector('.m-image-modal__container');
		let $close = $modal.querySelector('.m-image-modal__close');
		
		_init();
		
		function _init() {
			_update();
			document.addEventListener('update', _onUpdate);
			$close.addEventListener('click', _onClickClose);
		}
		
		function _onUpdate() {
			_update();
		}
		
		function _onClickLink( evt ) {
			evt.preventDefault();
			
			let $link = evt.currentTarget;
			let href = $link.getAttribute('href');
			
			if ( _isSp() ) {
				window.open( href );
			}
			else {
				_attach( href );
				_show();
			}
		}
		
		function _onClickClose( evt ) {
			evt.preventDefault();
			
			_hide();
		}
		
		function _update() {
			let $links = document.querySelectorAll('.j-image-modal');
			$links.forEach(( $link )=>{
				if ( ! $link.classList.contains('j-image-modal--initialized') ) {
					$link.classList.add('j-image-modal--initialized');
					$link.addEventListener('click', _onClickLink);
				}
			});
		}
		
		function _attach( url ) {
			$container.innerHTML = '';
			let $img = document.createElement('img');
			$img.setAttribute('src', url);
			$container.appendChild( $img );
		}
		
		function _show() {
			$modal.classList.add('is-visible');
		}
		
		function _hide() {
			$modal.classList.remove('is-visible');
		}
		
		function _isSp() {
			let ua = navigator.userAgent;
			return ua.match(/iPhone|Android.+Mobile/);
		}
	}

    // yotpo商品レビュータイトル調整（タイトルがレビューテキストのコピーだった場合にタイトル文字数を調整）
    function YotpoAddFunction() {
      // yotpo商品レビュー読み込み完了を待ちたいのでタイマー
      setTimeout(function(){
        let $yotpoReview = document.querySelectorAll('.yotpo-review');
        let maxlen = 15;// 制限する文字数
        $yotpoReview.forEach(function(elem){
          let _title = elem.querySelector('.yotpo-review-title').textContent.replaceAll(/\s+/g, '');
          let _text = elem.querySelector('.yotpo-read-more-text').textContent.replaceAll(/\s+/g, '');
          // タイトルとレビューテキストが一致
          if ( _text.indexOf(_title) == 0 ) {
            // かつ、タイトルの文字数が多い場合（maxlen以上）は文字数制限
            if ( _title.length >= maxlen ) {
              elem.querySelector('.yotpo-review-title').textContent = _title.substring(0, maxlen) + '...';
            }
          }
        });
      }, 3000);
    }
	
})();